const tr = {
  pleaseEnterUsername: "Lütfen bir kullanıcı adı girin",
  cannotFriendYourself: "Kendinize arkadaşlık isteği gönderemezsiniz.",
  friendRequestSent: "Arkadaşlık isteği gönderildi!",
  failedToSendRequest: "İstek gönderilemedi",
  linkCopied: "Bağlantı panoya kopyalandı!",
  backToInvites: "Davetlere Dön",
  sendFriendRequestByUsername: "Kullanıcı Adıyla Arkadaşlık İsteği Gönder",
  enterUsername: "Kullanıcı adını girin",
  send: "Gönder",
  yourInviteQrCode: "Davet QR Kodunuz",
  inviteLink: "Davet Bağlantısı",
  scanQrOrUseLink: "Arkadaşlık isteği göndermek için bu QR kodu tarayın veya bu bağlantıyı kullanın",
  copyInviteLink: "Davet bağlantısını kopyala",
  goToItem: "Öğeye Git",
  verificationEmailSent: "Doğrulama e-postası gönderildi! Gelen kutunuzu kontrol edin.",
  verificationEmailFailed: "Doğrulama e-postası gönderilemedi. Lütfen tekrar deneyin.",
  verifyYourEmail: "E-posta Adresinizi Doğrulayın",
  verifyEmailInstructions: "Hesabınıza erişmek için lütfen e-posta adresinizi doğrulayın. Doğrulama bağlantısı için gelen kutunuzu kontrol edin.",
  sending: "Gönderiliyor...",
  resendVerificationEmail: "Doğrulama E-postasını Yeniden Gönder",
  login: "Giriş Yap",
  register: "Kayıt Ol",
  home: "Ana Sayfa",
  calendar: "Takvim",
  friends: "Arkadaşlar",
  profile: "Profil",
  logout: "Çıkış Yap",
  loading: "Yükleniyor...",
  language: "Dil",
  calendarSelectPlaceSuggestion: "Koordinatların eklenebilmesi için lütfen önerilerden bir yer seçin.",
  calendarSelectDateAndTime: "Lütfen tarih ve saat seçin.",
  calendarPositiveDuration: "Lütfen pozitif bir süre girin.",
  calendarFutureDateRequired: "Etkinlik tarihi ve saati gelecekte olmalıdır.",
  calendarCreateEventFailed: "Etkinlik oluşturulamadı. Lütfen tekrar deneyin.",
  cancel: "İptal",
  createNewEvent: "Yeni Etkinlik Oluştur",
  week: "Hafta",
  month: "Ay",
  eventTitle: "Başlık",
  date: "Tarih",
  time: "Saat",
  duration: "Süre",
  endsAt: "Bitiş",
  place: "Yer",
  searchForPlace: "Yer ara",
  placeSearchTip: "İpucu: Yazmaya başlayın ve koordinatları eklemek için bir sonuç seçin.",
  description: "Açıklama",
  createEvent: "Etkinlik Oluştur",
  today: "Bugün",
  previousMonth: "Önceki ay",
  nextMonth: "Sonraki ay",
  previous: "Önceki",
  next: "Sonraki",
  mondayShort: "Pzt",
  tuesdayShort: "Sal",
  wednesdayShort: "Çar",
  thursdayShort: "Per",
  fridayShort: "Cum",
  saturdayShort: "Cmt",
  sundayShort: "Paz",
  more: "daha fazla",
  mustRespondWillBeforeReposting: "Yeniden paylaşmadan önce \"Katılacağım\" yanıtını vermelisiniz",
  event: "Etkinlik",
  backToCalendar: "Takvime Dön",
  addToGoogleCalendar: "Google Takvim'e Ekle",
  when: "Ne Zaman",
  where: "Nerede",
  openLocationInGoogleMaps: "Konumu Google Haritalar'da Aç",
  hosts: "Organizatörler",
  yourResponse: "Yanıtınız",
  currentResponse: "Mevcut Yanıt",
  response_will: "Katılacağım",
  response_might: "Belki katılırım",
  response_wont: "Katılmayacağım",
  willRunIntoYou: "Uğrayacağım",
  mightDropBy: "Belki uğrarım",
  wontCome: "Gelmeyeceğim",
  repostToMyFriends: "Arkadaşlarımla yeniden paylaş",
  responses: "Yanıtlar",
  willAttend: "Katılacak",
  reposted: "Yeniden paylaşıldı",
  mightAttend: "Belki katılacak",
  cancelEvent: "Etkinliği İptal Et",
  cancellationEmailNoticeBefore: "Katılacaklarını belirten kişiler",
  cancellationEmailNoticeAfter: "iptal hakkında e-posta ile bilgilendirilecektir.",
  optionalCancellationMessage: "Katılımcılar için isteğe bağlı mesaj (en fazla 1000 karakter)",
  confirmCancelEvent: "Etkinlik İptalini Onayla",
  clear: "Temizle",
  confirmCancellation: "İptali Onayla",
  confirmCancellationMessage: "Bu etkinliği iptal etmek istediğinizden emin misiniz? Bu işlem onaylı katılımcıları bilgilendirecek ve etkinliği kaldıracaktır.",
  eventCancelledNotified: "Etkinlik iptal edildi. Bildirilen kişi sayısı:",
  attendees: "katılımcı",
  failedToCancelEvent: "Etkinlik iptal edilemedi",
  back: "Geri",
  cancelled: "İptal Edildi",
  ok: "Tamam",
  forgotPassword: "Şifremi Unuttum",
  email: "E-posta",
  passwordResetLinkSent: "Hesap mevcutsa bir şifre sıfırlama bağlantısı gönderildi.",
  passwordResetRequestFailed: "Şifre sıfırlama isteği başarısız oldu.",
  sendResetLink: "Sıfırlama Bağlantısını Gönder",
  addFriend: "Arkadaş Ekle",
  incomingRequests: "Gelen İstekler",
  accept: "Kabul Et",
  deny: "Reddet",
  myFriends: "Arkadaşlarım",
  noFriendsYet: "Henüz arkadaşınız yok. Hemen arkadaş ekleyin!",
  seeProfile: "Profili Görüntüle",
  noEventsToRespondTo: "Yanıtlanacak etkinlik yok",
  allCaughtUp: "Her şey güncel. Arkadaşlarınızın yeni etkinlikleri için daha sonra tekrar kontrol edin.",
  events: "Etkinlikler",
  unknown: "Bilinmiyor",
  noDescriptionProvided: "Açıklama sağlanmadı.",
  will: "Evet",
  maybe: "Belki",
  wont: "Hayır",
  userNotFound: "Kullanıcı bulunamadı",
  friendRequestSentSuccessfully: "Arkadaşlık isteği başarıyla gönderildi!",
  friendInvitation: "Arkadaşlık Daveti",
  sendFriendRequest: "Arkadaşlık İsteği Gönder",
  loginToSendFriendRequest: "Arkadaşlık isteği göndermek için giriş yapın",
  chooseLanguage: "Dil Seçin",
  invalidCredentials: "Geçersiz kimlik bilgileri. Lütfen tekrar deneyin.",
  username: "Kullanıcı Adı",
  password: "Şifre",
  forgotPasswordQuestion: "Şifrenizi mi unuttunuz?",
  dontHaveAccount: "Hesabınız yok mu?",
  registerHere: "Buradan kayıt olun",
  invalidProfilePhotoType: "Geçersiz dosya türü. Lütfen JPEG, PNG, GIF veya WebP resmi yükleyin.",
  invalidFileExtension: "Geçersiz dosya uzantısı",
  allowedExtensions: "İzin verilenler",
  fileTooLarge: "Dosya çok büyük",
  maximumFileSize: "Maksimum",
  profilePhotoRemoved: "Profil fotoğrafı kaldırıldı.",
  failedToRemoveProfilePhoto: "Profil fotoğrafı kaldırılamadı",
  profileUpdatedSuccessfully: "Profil başarıyla güncellendi!",
  failedToUpdateProfile: "Profil güncellenemedi",
  privateEmailExplanation: "Platform dışındaki istenmeyen mesajları önlemek için e-posta adresinizi yalnızca siz görebilirsiniz",
  yourEmailIsPrivate: "E-posta adresiniz gizlidir.",
  profilePhoto: "Profil Fotoğrafı",
  removePhoto: "Fotoğrafı Kaldır",
  firstName: "Ad",
  lastName: "Soyad",
  tellPeopleAboutYourself: "Kendinizden bahsedin",
  whereToContactMe: "Bana Nasıl Ulaşılır",
  contactInfoPlaceholder: "Instagram: myUsername\nDiscord: myDiscord",
  save: "Kaydet",
  notSet: "Belirtilmedi",
  editProfile: "Profili Düzenle",
  imageToCrop: "Kırpılacak Resim",
  zoom: "Yakınlaştır",
  usePhoto: "Fotoğrafı Kullan",
  name: "Ad",
  whereToContact: "İletişim Bilgileri",
  removeFriendship: "Arkadaşlığı Kaldır",
  confirmRemoveFriend: "Arkadaş Kaldırmayı Onayla",
  confirmRemoveFriendBefore: "",
  confirmRemoveFriendAfter: "kişisini arkadaş listenizden kaldırmak istediğinizden emin misiniz?",
  friendRemoved: "Arkadaş kaldırıldı.",
  failedToRemoveFriend: "Arkadaş kaldırılamadı.",
  confirmRemove: "Kaldırmayı Onayla",
  error: "Hata",
  removed: "Kaldırıldı",
  passwordsDoNotMatch: "Şifreler eşleşmiyor",
  registrationFailed: "Kayıt başarısız oldu. Lütfen tekrar deneyin.",
  confirmPassword: "Şifreyi Onayla",
  alreadyHaveAccount: "Zaten bir hesabınız var mı?",
  loginHere: "Buradan giriş yapın",
  passwordResetSuccessfully: "Şifre başarıyla sıfırlandı.",
  failedToResetPassword: "Şifre sıfırlanamadı.",
  resetPassword: "Şifreyi Sıfırla",
  newPassword: "Yeni Şifre",
  confirmNewPassword: "Yeni Şifreyi Onayla",
  setNewPassword: "Yeni Şifreyi Ayarla",
  emailVerifiedSuccessfully: "E-posta başarıyla doğrulandı!",
  emailVerificationFailed: "Doğrulama başarısız oldu. Bağlantı geçersiz veya süresi dolmuş olabilir.",
  verifying: "Doğrulanıyor...",
  verified: "Doğrulandı!",
  redirectingToHome: "Ana sayfaya yönlendiriliyorsunuz...",
  verificationFailed: "Doğrulama Başarısız",
  goToHome: "Ana Sayfaya Git",
  about: "Hakkında",
  aboutConceptTitle: "Konsept",
  aboutCreatorIntroduction: "Merhaba, ben Crypt0; bir kaya tırmanıcısı ve Run Into Me'nin geliştiricisiyim.",
  aboutCreatorStory: "Bu siteyi sosyal olduğum ve diğer tırmanıcılarla etkinlik düzenlemeye fazla zaman harcadığım için oluşturdum.",
  aboutPlanningProblem: "Resmî davet göndermeden ne zaman ve nerede tırmanacağımı herkese aynı anda bildirmek istedim.",
  aboutDeveloperSolution: "Sonra geliştirici olduğumu ve çözümü kendim yapabileceğimi hatırladım.",
  aboutWelcome: "Arkadaşlarınıza baskı olmadan katılabilecekleri etkinlikleri bildirebileceğiniz Run Into Me'ye hoş geldiniz.",
  aboutCallToAction: "Birlikte daha eğlenceli olacak bir sonraki etkinliğinizi burada paylaşın!",
  aboutTutorialTitle: "Eğitim",
  aboutCalendarCreateEvent: "Takvim ekranında yeni bir etkinlik de oluşturabilirsiniz.",
  aboutEventColorsIntroduction: "Renkler katılım durumunuzu gösterir:",
  aboutColorGold: "Altın",
  aboutColorGoldDescription: "Bu etkinliğe ev sahipliği yapıyorsunuz.",
  aboutColorGreen: "Yeşil",
  aboutColorGreenDescription: "Bu etkinliğe katılıyorsunuz.",
  aboutColorOrange: "Turuncu",
  aboutColorOrangeDescription: "“Belki” yanıtını verdiniz.",
  aboutColorBlue: "Mavi",
  aboutColorBlueDescription: "Henüz yanıt vermediniz.",
  aboutColorGray: "Gri",
  aboutColorGrayDescription: "Daveti reddettiniz.",
  aboutCalendarEventDetails: "Bilgi ve yanıt için etkinliğe tıklayın.",
  aboutFriendPageTitle: "Arkadaşlar Sayfası",
  aboutFriendPageDescription: "Kullanıcı adını girin veya davet bağlantısı / QR kodu gönderin.",
  aboutHomePageTitle: "Ana Sayfa",
  aboutHomePageDescription: "Yaklaşan etkinlikleri inceleyip katılımınızı bildirin.",
  aboutRepostScreenTitle: "Yeniden Paylaşım Ekranı",
  aboutGoogleCalendarDescription: "Bu düğmeyle etkinliği Google Takvim’e ekleyin.",
  aboutRepostDescription: "Katılımı onayladıktan sonra etkinliği arkadaşlarınıza yeniden paylaşabilirsiniz.",
};

export default tr;
